import { render, staticRenderFns } from "./SwitchTableByPin.vue?vue&type=template&id=c3540574&scoped=true&"
import script from "./SwitchTableByPin.vue?vue&type=script&lang=js&"
export * from "./SwitchTableByPin.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTableByPin.vue?vue&type=style&index=0&id=c3540574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3540574",
  null
  
)

export default component.exports